import { Controller } from "react-hook-form";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";

const FlexControlledDatePickerSeparatedLabel = ({
	control,
	name,
	error,
	label,
	options,
	labelProps,
	className,
	labelStyles,
	inputStyles,
	checkboxStyles,
	...rest
}) => {
	return (
        <Controller
			control={control}
			name={name}
			render={({ field: { onChange, value } }) => (
				<Box
					sx={{
						display: "flex",
						gap: "10px",
						alignItems: "center",
						width: "100%",
					}}
				>
					<Box
						sx={{
							flex: "0",
							display: "flex",
							alignItems: "center",
							height: "100%",
							...labelStyles,
						}}
					>
						<Typography
							noWrap
							variant="label"
							component="label"
							htmlFor={name}
							sx={{ ...labelProps }}
						>
							{label}:
						</Typography>
					</Box>
					<Box
						sx={{
							flex: "1",
							display: "flex",
							alignItems: "center",
							...inputStyles,
						}}
					>
						<DatePicker
							format="DD/MM/YYYY"
							onChange={onChange}
							value={value ? moment(value) : null}
							renderInput={(params) => (
								<TextField
									required
									size="small"
									{...params}
									sx={{
										"& .MuiIconButton-root": {
											padding: "0 4px 0 0",
										},
									}}
									slotProps={{
                                        inputLabel: { shrink: true }
                                    }}
								/>
							)}
						/>
					</Box>
				</Box>
			)}
		/>
    );
};

export default FlexControlledDatePickerSeparatedLabel;
